export enum ElasticSearchFilterPaths {
  AVAILABILITY = 'availability',
  CONTEXTS = 'contexts',
  CRITERIASETS = 'criteria-sets',
  KDSMODULES = 'kds-modules',
  TERMINOLOGIES = 'terminologies',
  VALUESETS = 'value-sets',
}
